import { handleApiError, handleApiResponse } from "@/methods/api";
import ApiVerified from "@/services/apiVerified";
import { ApiResponse } from "@/types/global";
import { Olympiad, Syllabus } from "@/types/olympiad";

export default class OlympiadApi extends ApiVerified {
  async getOlympiadForStudent(userId: number): Promise<ApiResponse> {
    try {
      const response = await this.axiosInstance.get<Olympiad>(`olympiad/get-olympiad-for-student`, {
        params: { userId: userId },
      });
      return handleApiResponse(response);
    } catch (error) {
      return handleApiError(error);
    }
  }

  async getSyllabusForStudent(userId: number): Promise<ApiResponse> {
    try {
      const response = await this.axiosInstance.get<Record<string, Array<Syllabus>>>(
        `olympiad/get-syllabus-for-student`,
        { params: { userId: userId } },
      );
      return handleApiResponse(response);
    } catch (error) {
      return handleApiError(error);
    }
  }
}
